import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "./ui/select";
import { TEXTURES, TEXTURE_CATEGORIES, getTexture } from "../lib/textures";

const NONE = "__none__";

// Compact texture dropdown with thumbnails. Reusable anywhere.
export function TextureSelect({ value, onChange }) {
  const selected = getTexture(value);
  return (
    <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? "" : v)}>
      <SelectTrigger className="border-zinc-300 h-9 text-sm w-56" data-testid="texture-select">
        <SelectValue>
          <span className="flex items-center gap-2">
            {selected ? (
              <>
                <img src={selected.url} alt="" className="w-5 h-5 object-cover rounded-sm" />
                <span className="truncate">{selected.label}</span>
              </>
            ) : (
              <span className="text-zinc-400">No texture</span>
            )}
          </span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="max-h-80">
        <SelectItem value={NONE}>No texture</SelectItem>
        {TEXTURE_CATEGORIES.map((cat) => (
          <SelectGroup key={cat}>
            <SelectLabel className="text-[10px] uppercase tracking-[0.15em] text-zinc-400">{cat}</SelectLabel>
            {TEXTURES.filter((t) => t.category === cat).map((t) => (
              <SelectItem key={t.id} value={t.id} data-testid={`texture-option-${t.id}`}>
                <span className="flex items-center gap-2">
                  <img src={t.url} alt="" className="w-5 h-5 object-cover rounded-sm" loading="lazy" />
                  <span className="truncate">{t.label}</span>
                </span>
              </SelectItem>
            ))}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
}
